/**
 * Build prefilled WhatsApp messages for different lead types.
 * Each helper returns a string ready to URL-encode into a wa.me link.
 */

const LINE = "\n";
const TITLE = "Hello Team KOSTRA Hospitality,";
const FOOTER = "Please get in touch.\n\nThank You.";

const kv = (label, val) => (val ? `${label}: ${val}` : null);

export function buildProductDevMessage(f) {
  const lines = [
    TITLE,
    "",
    "I'd like to discuss a *Product Development* requirement.",
    "",
    kv("Company", f.company_name),
    kv("Contact Person", f.contact_person),
    kv("Mobile", f.mobile),
    kv("Email", f.email),
    kv("Product Category", f.product_category),
    kv("Sample File", f.sample_file_name),
    f.product_description ? `\nBrief:\n${f.product_description}` : null,
    "",
    FOOTER,
  ].filter(Boolean);
  return lines.join(LINE);
}

export function buildConsultancyMessage(f) {
  const lines = [
    TITLE,
    "",
    "I'd like to discuss a *Food Consultancy* requirement.",
    "",
    kv("Company", f.company_name),
    kv("Contact Person", f.contact_person),
    kv("Mobile", f.mobile),
    kv("Email", f.email),
    kv("Business Type", f.business_type),
    kv("City", f.city),
    f.requirement ? `\nRequirement:\n${f.requirement}` : null,
    "",
    FOOTER,
  ].filter(Boolean);
  return lines.join(LINE);
}

export function buildContactMessage(f) {
  const lines = [
    TITLE,
    "",
    "I have a query and would like to connect.",
    "",
    kv("Name", f.name),
    kv("Mobile", f.mobile),
    kv("Email", f.email),
    f.message ? `\nMessage:\n${f.message}` : null,
    "",
    FOOTER,
  ].filter(Boolean);
  return lines.join(LINE);
}

export function buildFranchiseMessage(f) {
  const lines = [
    TITLE,
    "",
    "I'm interested in *Franchise / Partnership* opportunities.",
    "",
    kv("Name", f.name),
    kv("Phone", f.phone),
    kv("Email", f.email),
    kv("City", f.city),
    kv("Business Type", f.business_type),
    f.message ? `\nNote:\n${f.message}` : null,
    "",
    FOOTER,
  ].filter(Boolean);
  return lines.join(LINE);
}

/** Opens wa.me in a new tab with the given prefilled message. */
export function openWhatsApp(phone, message) {
  const digits = (phone || "").replace(/[^0-9]/g, "");
  const url = `https://wa.me/${digits}?text=${encodeURIComponent(message)}`;
  // Open immediately; some browsers block if delayed past user gesture.
  const w = window.open(url, "_blank", "noopener,noreferrer");
  if (!w) {
    // Fallback: navigate current tab
    window.location.href = url;
  }
}
